export default {
    validation: {
        alpha: "Alphanumeric characters only.",
        email: "لطفا ایمیل معتبر وارد کنید.",
        minLength: "حداقل {{min}} کاراکتر وارد نمایید.",
        maxLength: "حداکثر {{max}} کاراکتر وارد نمایید.",
        required: "بخش مورد نظر را کامل کنید.",
        sameAsPassword: "تکرار رمز عبور باید همانند رمز عبور باشد.",
        phone: "لطفا شماره تلفن معتبر وارد نمایید.",
        emailOrPhone: 'یک ایمیل یا شماره تلفن همراه معتبر وارد کنید.',
        slug: "لطفا کلمات را بدون فاصله وارد کنید.",
        numeric: 'لطفا فقط از عدد استفاده نمایید.',
        integer: 'لطفا فقط از عدد استفاده نمایید.',
        telphone: "لطفا شماره تلفن معتبر وارد نمایید.",
        postalcode: "لطفا کدپستی معتبر وارد نمایید.",
        url: "لطفا لینک معتبر وارد نمایید.",
        phoneStartWith98: 'شماره تلفن همراه باید با +98 آغاز شده و کاراکتر ها عدد باشند.',
    }
}
